import { render, staticRenderFns } from "./XmPublicMultipleChoice.vue?vue&type=template&id=6ffc71a0&scoped=true"
import script from "./XmPublicMultipleChoice.vue?vue&type=script&lang=js"
export * from "./XmPublicMultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./XmPublicMultipleChoice.vue?vue&type=style&index=0&id=6ffc71a0&prod&lang=scss&scoped=true"
import style1 from "./XmPublicMultipleChoice.vue?vue&type=style&index=1&id=6ffc71a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffc71a0",
  null
  
)

export default component.exports